module.exports = __webpack_public_path__ + "static/img/banner-4.a7fb020.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banners/banner-4.png
// module id = zd6A
// module chunks = 1